import { render, staticRenderFns } from "./View.vue?vue&type=template&id=12b4d59c&"
import script from "./View.vue?vue&type=script&lang=js&"
export * from "./View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12b4d59c')) {
      api.createRecord('12b4d59c', component.options)
    } else {
      api.reload('12b4d59c', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=12b4d59c&", function () {
      api.rerender('12b4d59c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/customers/View.vue"
export default component.exports